import { useEffect, useState } from 'react'

export const useRewardful = () => {
  const [referral, setReferral] = useState(null)
  const [rewardfulReady, setRewardfulReady] = useState<boolean>(false)

  // Effect for initializing Rewardful
  useEffect(() => {
    // Check if rewardful exists in the window object
    if ((window as any).rewardful) {
      ;(window as any).rewardful('ready', function () {
        setReferral((window as any).Rewardful.referral)
        setRewardfulReady(true) // Set to true when ready
      })
    } else {
      // Assume ready if rewardful does not exist
      setRewardfulReady(true)
    }
  }, [])

  return { referral, rewardfulReady }
}
